import { Button, Grid, MenuItem, TextField, Typography, Modal, Box, IconButton, Card } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import InviteIcon from '../../assets/invite.svg';
import useInviteStyles from './invite.styles';
import STATIC_TEXT from '../../content/common.json';
import Spacing from '../portico/spacing/spacing';
import Dialog from '../portico/dialog/dialog';
import FormInput from '../portico/input/form-input';
import { deleteCollaborator, fetchCollaborators, inviteCollaborator } from '../../services/bff-service';
import { useForm } from 'react-hook-form';
import CONSTANTS from '../../utils/constants';
import { setSnackBar } from "../../stores/ui/ui-action";
import { useDispatch } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import CustomLoading from '../custom/custom-loading';
import { userLogin } from "../../services/identity-service";
import CheckIcon from "@mui/icons-material/Check";
import Warning from '@material-ui/icons/Warning';
import Error from '@material-ui/icons/Error';

interface InviteProps {
    showButton?: boolean,
    journeyId: string
}

const Invite: React.FC<InviteProps> = (props): JSX.Element => {

  const [openInviteDialog, setInviteDialog] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  // const [fetchError, setFetchError] = useState(null);
  const classes = useInviteStyles();
  const emailRegex = CONSTANTS.EMAIL_REGEX;
  const dispatch = useDispatch();
  const [collaboratorDetails, setCollaboratorDetails] = useState({
    'firstName': "",
    'lastName': "",
    'email': '',
    'countryCode': '1',
    "smsEnabledPhoneNumber": '',
    "confirmPhoneNumber": ''
  });

  const { register, formState: { errors }, setValue,
    formState: {isValid}, setError, clearErrors, getValues} = useForm({defaultValues: {
    'firstName': "",
    'lastName': "",
    'email': '',
    'countryCode': '1',
    "smsEnabledPhoneNumber": '',
    "confirmPhoneNumber": ''
  }, mode: "onBlur"});

  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [resentEmails, setResentEmails] = useState(new Set());
  const [isRemoveCollaborator, setIsRemoveCollaborator] = useState(false);
  const [emailToRemove, setEmailToRemove] = useState('');
  const [associationId, setAssociationId] = useState('');
  const [isUserExists, setIsUserExists] = useState(false);

    const onCloseInviteDialog = () => {
        setInviteDialog(false);
    }

    const getCollaboratorDetails = async () => {
      const response = await fetchCollaborators(props.journeyId);

      setCollaborators(response);
    }

    const handleSubmit = () => {
      const data = getValues();
      const collaborator = checkIfUserAlreadyPresent(data.email);

       if(collaborator) {
        setIsUserExists(true);
        return;
      }

      setCollaboratorDetails(data);

      if(data.smsEnabledPhoneNumber !== data.confirmPhoneNumber) {
        setError('confirmPhoneNumber', {
          type: 'manual',
          message: "Phone number does not match"});
        return;
      } else {
        clearErrors('confirmPhoneNumber');
      }
      
      setOpen(true);
    }

    const checkIfUserAlreadyPresent = (email) => {
      return collaborators.find((collaborator) => collaborator.email == email);
    }

    const formatMobileNumber = (e) => {
      const value = e.target.value;
      const onlyNumbers = value.replace(/[^0-9]/g, "");
      if (onlyNumbers.length < 10) {
        return onlyNumbers;
      } else if (onlyNumbers.length === 10) {
        return onlyNumbers.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
    };  

    const onConfirm = async () => {
      let payload = getValues();
      payload = {
        ...payload, 
        ['smsEnabledPhoneNumber']: payload.smsEnabledPhoneNumber.replace(/-/g, ""), 
        ['confirmPhoneNumber']: payload.confirmPhoneNumber.replace(/-/g, "")
      }
      payload["journey_id"] = props.journeyId;
      sendInvite(payload);
    }

    const handleClose = () => {
      setOpen(false);
    }

        
    const onOpenInviteDialog = () => {
      setInviteDialog(true);
      getCollaboratorDetails();
      setResentEmails(new Set());
    }

    const resendInvite = async (email) => {
      const login = await userLogin(email, 'welcome');

      if(login) {
        setResentEmails(new Set([...resentEmails, email]));
        setTimeout(() => {
          setInviteDialog(false);
        }, 4000);
      }
    }

    const sendInvite = async (payload) => {
      setSubmitting(true);
      
      try {
        payload.journeyId = props.journeyId
        const response = await inviteCollaborator(payload);

        if(response.transactionId) {
          setOpen(false);
          setInviteDialog(false);
          dispatch(setSnackBar({
            show: true,
            message: `Invite sent to ${payload.email}`,
            messageType: "success"
          }))
        } else {
          dispatch(setSnackBar({
            show: true,
            message: response.message,
            messageType: "error"
          }));

          setOpen(false);
        }
        setSubmitting(false);
      }catch(e) {
        setSubmitting(false);
        dispatch(
          setSnackBar({
            show: true,
            message: "Invitation failed. Please try again",
            messageType: "error",
          })
        );
      }
    }

    const handleRemoveCollaborator = (associationId, email) => {
      setEmailToRemove(email);
      setAssociationId(associationId);
      setIsRemoveCollaborator(true);
    }

    const onRemoveConfirm = async () => {
      await deleteCollaborator(associationId, props.journeyId);
      setIsRemoveCollaborator(false);
      setInviteDialog(false);
  }


    return (
        <>
        {submitting && <CustomLoading message="Loading..." />}
        <Button
            disableRipple
            disableElevation
            onClick={onOpenInviteDialog}
            data-testid="app-invite"
            data-cy="invite-btn"
            variant={props.showButton ? 'contained' : 'text'}
            className={props.showButton ? classes.heroButton : classes.button}
            startIcon={<img src={InviteIcon} alt="Invite" className={props.showButton ? classes.heroIcon : classes.icon} /> }
            >
            <span className={props.showButton ? classes.heroText : undefined}>Invite Collaborator</span>
        </Button>
        <div>
            <Dialog
                title={STATIC_TEXT.inviteDialog.title}
                open={openInviteDialog}
                cancelBtnLabel='Cancel'
                onCancel={onCloseInviteDialog}
                okBtnLabel='Send Invite'
                onOk={handleSubmit}
                disableActions={false}
                disableOk={!isValid}
                okBtnClasses={isValid ? classes.btn_primary : classes.btn_disabled}
                >
                <Typography variant="body1">
                  <p>{STATIC_TEXT.inviteDialog.subtitle}</p>
                  <Spacing variable='spacing-base-x2'/>
                  <form>
                    <div className={classes.contentClass}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <FormInput
                            data-testid="firstName"
                            name='firstName'
                            label="First Name"
                            isRequired={true}
                            ref={register({
                              required: {
                                value: true,
                                message: "First name is required"
                              }
                            })}
                            error={errors["firstName"]}
                            setValue={setValue}
                          ></FormInput>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormInput
                            data-testid="lastName"
                            name='lastName'
                            label="Last Name"
                            isRequired={true}
                            ref={register({
                              required: {
                                value: true,
                                message: "Last name is required"
                              }
                            })}
                            error={errors["lastName"]}
                            setValue={setValue}
                          ></FormInput>
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <FormInput
                            label="Email"
                            name="email"
                            setValue={setValue}
                            data-testid="email"
                            isRequired={true}
                            ref={register({
                              required: {
                                value: true,
                                message: "Email is required"
                              },
                              validate: value => {
                                if (!value.match(emailRegex)) {
                                  return "Please enter a valid email address";
                                }
                              }
                            })}
                            error={errors['email']}
                          ></FormInput>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            select
                            label="Phone Country Code"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled={true}
                            className={classes.countryCode}
                            name="countryCode"
                            value={1}
                          >
                            <MenuItem value={1}>United States (+1)</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormInput
                            label="SMS-enabled Phone Number"
                            name='smsEnabledPhoneNumber'
                            setValue={setValue}
                            data-testid="smsEnabledPhoneNumber"
                            isRequired={true}
                            onChange={(e) => {
                              const number = formatMobileNumber(e);
                              setValue('smsEnabledPhoneNumber',number);
                            }}
                            ref={register({
                              required: {
                                value: true,
                                message: "SMS-enabled phone number is required"
                              },
                              validate: value => {
                                if(value.replace(/-/g, "").length != 10) {
                                  return "Please enter a valid phone number";
                                }
                              }
                            })}
                            error={errors['smsEnabledPhoneNumber']}
                          ></FormInput>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            select
                            label="Phone Country Code"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled={true}
                            className={classes.countryCode}
                            value={1}
                            name='countryCode'
                          >
                            <MenuItem value={1}>United States (+1)</MenuItem>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <FormInput
                            label="Confirm Phone Number"
                            name='confirmPhoneNumber'
                            setValue={setValue}
                            isRequired={true}
                            onChange={(e) => {
                              const number = formatMobileNumber(e);
                              setValue('confirmPhoneNumber',number);
                            }}
                            ref={register({
                              required: {
                                value: true,
                                message: "Confirm phone number is required"
                              },
                              validate: value => {
                                if(value.replace(/-/g, "").length != 10) {
                                  return "Please enter a valid phone number";
                                }
                              }
                            })}
                            error={errors['confirmPhoneNumber']}
                          ></FormInput>
                        </Grid>

                      </Grid>
                    </div>
                  </form>
                  {collaborators.length > 0 &&
                    <div className={classes.card}>
                      <p className={classes.cardHeader}>Manage Collaborators</p>
                      {collaborators.map(collaborator => (
                        <Grid container spacing={2} className={classes.cardItem}>
                          <Grid item xs={12} md={7}>
                              <p className={classes.cardItemHeader}>{collaborator.firstName} {collaborator.lastName}</p>
                              <p className={classes.cardItemContent}>{collaborator.email}</p>
                              <p className={classes.cardItemContent}>{collaborator.countryCode} {collaborator.phoneNumber}</p>
                          </Grid>
                          <Grid item xs={12} md={5}>
                            {resentEmails.has(collaborator.email) ? <Button variant='text' style={{pointerEvents: 'none'}}><span style={{color:'green',display:'flex',alignItems:'center', gap: '0.25em'}}><CheckIcon />Resent</span></Button> :
                              <Button variant='text' color='primary' onClick={() => resendInvite(collaborator.email)}>Resend Invite</Button>
                            }
                            <Button variant="text" color="primary" onClick={() => handleRemoveCollaborator(collaborator.associationId, collaborator.email)}>Remove</Button>
                          </Grid>
                        </Grid>
                      ))}
                    </div>
                  }
                </Typography>
                <Spacing variable="spacing-base-x2" />
            </Dialog>

            <Modal
                open={open}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                data-testid="confirmModal"
              >
                <Box className={classes.modalBox}>
                  <IconButton aria-label="close" onClick={handleClose} style={{ float: "right" }}>
                    <CloseIcon />
                  </IconButton>
                  <div className={classes.boxContent}>
                    <Typography className={classes.contentText} id="modal-title" variant="h6">
                      Confirm Contact Info
                    </Typography>
                    <Spacing></Spacing>
                    <Typography id="modal-description">
                      Please confirm collaborator details, including their mobile number, as they will be used to validate their identity:
                    </Typography>
                    <Spacing></Spacing>
                    <Spacing></Spacing>
                    <Spacing></Spacing>

                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12} className={classes.contentText}>
                      <span>Name</span>
                    </Grid>
                    <Grid item md={8} xs={12}>
                      {collaboratorDetails.firstName} {collaboratorDetails.lastName}
                    </Grid>
                    <Grid item md={4} xs={12} className={classes.contentText}>
                      <span>Email</span>
                    </Grid>
                    <Grid item md={8} xs={12}>
                      {collaboratorDetails?.email}
                    </Grid>
                    <Grid item md={4} xs={12} className={classes.contentText}>
                      <span>Mobile Number</span>
                    </Grid>
                    <Grid item md={8} xs={12}>
                      +1 {collaboratorDetails.smsEnabledPhoneNumber}
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.btnContainer}>
                  <Button color="primary" onClick={handleClose} data-testid="confirmCancel">
                    <span>Cancel</span>
                  </Button>
                  <Button className={classes.btn_primary} onClick={onConfirm} data-testid="confirmSubmit">
                    <span>Confirm & Invite</span>
                  </Button>
                </div>
              </Box>
            </Modal>

            <Modal
              open={isRemoveCollaborator}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
              data-testid="removeCollaborator"
            >
              <div className={`${classes.removeCollabModal} ${classes.modalBox}`}>
                <div className={classes.modalContent}>
                  <div className={classes.heading}>
                    <Warning className={classes.warningIcon}/>
                    <h3>Remove Collaborator</h3>
                  </div>
                  <p>Are you sure you want to remove {emailToRemove} as a Collaborator?</p>
                </div>
                <div className={classes.btnContainer}>
                  <Button color="primary" onClick={() => {setEmailToRemove(''); setIsRemoveCollaborator(false);}} data-testid="confirmCancel">
                    <span>Cancel</span>
                  </Button>
                  <Button className={classes.btn_primary} onClick={() => onRemoveConfirm()} data-testid="confirmSubmit">
                    <span>Confirm</span>
                  </Button>
                </div>
              </div>
            </Modal>

            <Modal
              open={isUserExists}
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
              data-testid="userExists"
            >
              <div className={`${classes.removeCollabModal} ${classes.modalBox}`}>
                <div className={classes.modalContent}>
                  <div className={classes.heading}>
                    <Error className={classes.errorIcon}/>
                    <h3>Email Already Assigned</h3>
                  </div>
                  <p>This email address is already assigned to another application, please check with the owner before inviting them as a collaborator.</p>
                </div>
                <div className={classes.btnContainer}>
                  <Button className={classes.btn_primary} onClick={() => {setIsUserExists(false);}} data-testid="confirmOk">
                    <span>Ok</span>
                  </Button>
                </div>
              </div>
            </Modal>
          </div>
        </>
      )
}

export default Invite;